import { make } from 'vuex-pathify';
import { getToday } from 'src/utils/dateOperations/getISODateText';
// all state from below is passed to backend starting rpc API v1.  it is done in getSessionContext() function, by doing ...(store.state['sessionContext'])
const state = {
    as_of_date: getToday(),
    scope_date_from: getToday(),
    scope_date_to: getToday(),
    scope_date_offset: 0,
    search_term: null
};
const mutations = make.mutations(state);
const namespaced = true;
const getters = {};
const actions = {};
export default { state, actions, mutations, namespaced, getters };
